import React from 'react'
import auth from "./auth"

function SignOut({classes, callback}) {
    return (
        <button className="signout_btn" onClick={(e)=>{
            e.preventDefault();

            auth.auth().signOut().then(() => {
                //invoke callback
                callback();
              }).catch((error) => {
                // An error happened.
              });
              
        }}>

        Ausloggen
            
        </button>
    )
}


function SignOutDirect() {
    auth.auth().signOut().then(() => {
        console.log("Signed out")
      }).catch((error) => {
        console.log("Error on Signed out")
      });
}


export {SignOut, SignOutDirect}
